import { render, staticRenderFns } from "./SignerProjectsOverview.vue?vue&type=template&id=0d14d1c2"
import script from "./SignerProjectsOverview.vue?vue&type=script&lang=js"
export * from "./SignerProjectsOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports